import React from 'react';
import clsx from 'clsx';
import {
    MenuItem,
    Menu,
    ClickAwayListener,
} from "@material-ui/core";
import RowElement from '../DataElements/RowElement'
import {
    NameTextField,
} from '../../../styling/Styles'

const InputComponent = (props) => {

    const{
        deleteComponent,
        typeInfo,
        changeType,
        placeholder,
        changePlaceholder,
        required,
        changeCheckbox
    } = props

    const [displayContent, setDisplayContent] = React.useState(false); 
    const [clickedEditType, setClickedEditType] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const InputTypes = ['text', 'email', 'number', 'password'];

    const changeEditTypeRequest = (event) => {
        setClickedEditType(true);
        setAnchorEl(event.currentTarget);
    }

    const closeMenu = () => {
        setClickedEditType(false);
        setAnchorEl(null);
    }

    return(
        
        <div className={clsx('spacingTopDiv')}>
            <RowElement
                label='Input'
                displayContent={displayContent}
                setDisplayContent={setDisplayContent}
                deleteElement={deleteComponent}
            />

            <div className={clsx('spacingTopDiv', 'spacingLeftDiv','spacingRightDiv')} style={displayContent !== true ? {display: 'none'}: {display: 'inherit'} }>  
                <div 
                    className={clsx('teamSelector', 'spacingTopDiv')} 
                    >
                        <span>Input type: &nbsp;
                            <span style={{marginLeft: '6.2vw'}} className ={clsx('teamSelector')} onClick={(event) => changeEditTypeRequest(event)} aria-hidden="true">{typeInfo}&nbsp;</span> 
                            &nbsp;
                        </span>
                        {clickedEditType === false ? 
                            <i className={clsx('fa', 'fa-caret-down', 'fa-caret-down2','teamSelector')}/>
                            : 
                            <ClickAwayListener 
                                onClickAway ={closeMenu}
                            >
                                <i className={clsx('fa', 'fa-caret-up', 'teamSelector')} />
                            </ClickAwayListener>
                        }
                </div>
                <Menu   
                    elevation={0}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    anchorEl={anchorEl}
                    keepMounted
                    open={clickedEditType}
                    >   
                        {
                            InputTypes.map((option) => (
                                <MenuItem 
                                    key={option}
                                    onClick ={() => changeType(option)}
                                > 
                                    {option}
                                </MenuItem>
                            ))
                        }
                </Menu>
                <div className={clsx('flexRowDirection','spacingTopDiv')}>
                    <div> Placeholder : &nbsp;  </div>
                    <span style={{marginLeft: '4.8vw'}}>&nbsp;</span>
                    <NameTextField 
                        id='PlaceholderType'
                        value={placeholder}
                        onInput={e =>changePlaceholder(e)}
                    />
                </div>
                <div className={clsx('flexRowDirection','spacingTopDiv')}>
                    <div> Required &nbsp;</div>
                    <span style={{marginLeft: '6.8vw'}}/>
                    <input 
                        type='checkbox'
                        checked= {required}
                        onChange={changeCheckbox}
                        style={{width: '1vw', height: '1vw', marginTop: '0.2vw'}}
                    />
                </div>
            </div>
            <hr className={clsx('blueLine','spacingTopDiv')}/> 

        </div>
    )
}

export default InputComponent;